import {GlobalParentVerificationIsCompletedVo} from '../../common/shared/api/nicolas/GlobalParentVerificationIsCompletedVo';
import {GlobalParentVerificationIsCompleted} from '../generated/types';

export const createGlobalParentVerificationIsCompleted = (
  data: GlobalParentVerificationIsCompletedVo
): GlobalParentVerificationIsCompleted => {
  return {
    isCompleted: data.is_completed,
  };
};
